import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
// 导入字体图标
import './assets/fonts/iconfont.css'
// 导入全局样式表
import './assets/css/global.css'
import TreeTable from 'vue-table-with-tree-grid'

// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'

// 导入 NProgress 包对应的JS和CSS
import NProgress from 'nprogress'

import axios from 'axios'
// 配置请求的跟路径
// axios.defaults.baseURL = 'https://hsapi.hsxsn.cn/'
axios.defaults.baseURL = 'https://hsapi.hsxsn.cn/'
// axios.defaults.baseURL = 'http://hkmtest.lanje.cn/'
// axios.defaults.baseURL = 'http://huangshi-localhost/'
// axios.defaults.baseURL = 'https://hsznttghpt.hsxsn.cn/'//特通供货
// axios.defaults.baseURL = 'https://purchase.hsxsn.cn/'//测试
    // 在 request 拦截器中，展示进度条 NProgress.start()
axios.interceptors.request.use(config => {
        // console.log(config)
        const phone = localStorage.getItem('phone')
        if (phone) {
            // 注意：config.method 的判断值必须是小写的post和get
            if (config.method === 'post') {
                config.data = {
                    mPhone: phone,
                    ...config.data
                }
            } else if (config.method === 'get') {
                config.params = {
                    mPhone: phone,
                    ...config.params
                }
            }
        }

        NProgress.start()
        config.headers.Authorization = window.sessionStorage.getItem('token')
            // 在最后必须 return config
        return config
    })
    // 在 response 拦截器中，隐藏进度条 NProgress.done()
axios.interceptors.response.use(config => {
    NProgress.done()
    return config
})
Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.component('tree-table', TreeTable)
    // 将富文本编辑器，注册为全局可用的组件
Vue.use(VueQuillEditor)

Vue.filter('dateFormat', function(originVal) {
    const dt = new Date(originVal)
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')
    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
